/**
 * Scheduling guide — cron, interval, webhook, and email triggers.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { schedulingContent } from "@/constants/docs/scheduling";

export const Route = createFileRoute("/docs/scheduling")({
	component: SchedulingPage,
});

function SchedulingPage() {
	return <DocsPage title="Scheduling" content={schedulingContent} />;
}
